import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3f49772"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "c-checkbox__field"
}, null, -1))
const _hoisted_2 = { class: "c-checkbox__label-radio c-checkbox__label-radio--altapay text-silver" }
const _hoisted_3 = { class: "block ml-5 mr-10 w-20 py-1" }

import useAltaPayPaymentMethods from '@/shared/checkout/altapay/useAltaPayPaymentMethods';
import SkeletonLine from '@/shared/spinners/SkeletonLine.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AltaPayPaymentMethods',
  setup(__props) {

const { setPaymentMethodsContainer } = useAltaPayPaymentMethods();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: _unref(setPaymentMethodsContainer),
    class: "payment-methods"
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1], (dummy) => {
      return _createElementVNode("div", {
        key: dummy,
        class: "c-checkbox"
      }, [
        _hoisted_1,
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(SkeletonLine, { class: "h-18" })
          ]),
          _createVNode(SkeletonLine, { class: "max-w-130" })
        ])
      ])
    }), 64))
  ], 512))
}
}

})